export const Footer = () => <footer>Footer</footer>
